import UniversalBarraBusquedaCursos from "../../../components/UniversalBarraBusquedaCursos/UniversalBarraBusquedaCursos";
import { WebSocketProvider } from "../../../context/WebSocketContext";

import React, { useContext, useEffect, useState } from "react";
import UniversalMenuHeader from "../../../components/UniversalMenuHeader";
import UniversalTarjetaCurso from "../../../components/UniversalTarjetaCurso";
import SubEmpaginador from "./components/SubEmpaginador";
import UniversalBarraBusqueda from "../../../components/UniversalBarraBusqueda";
import SubFilter from "./components/SubFilterSearch/SubFilterSearch";
import { useSearchParams } from "react-router-dom";
import { getCategoriaData } from "../Home/services/homeService";
import { getCursosEmpaginados } from "./services/cursosService";
//Imports de los modals
import UModalLogin from "../../../components/UModalLogin/UModalLogin.jsx";
import UModalContactanos from "../../../components/UModalContactanos/UModalContactanos.jsx";
import UModalEnviarCorreo from "../../../components/UModalEnviarCorreo/UModalEnviarCorreo.jsx";
import UModalCambiarContraseñaTemporal from "../../../components/UModalCambiarContraseñaTemporal/UModalCambiarContraseñaTemporal.jsx";
import UModalRecetContraseña from "../../../components/UModalRecetContraseña/UModalRecetContraseña.jsx";
import { useNavigate } from "react-router-dom";
import { WindowSizeContext } from "../../../context/WindowSizeContext.jsx"; //Se usa para calcular el ancho de los modals
// Estos es para que busque cursos sin websocket

//________________________//

export default function Cursos({ vCategoriasIds = 0 }) {
  let [searchParams] = useSearchParams();
  const [vCursosPopulares, setVCursosPopulares] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResultados, setTotalResultados] = useState(0);
  const [vCategorias, setVCategorias] = useState([]);
  const [vCategoriesSelected, setVCategoriesSelected] = useState(
    searchParams.get("categoria_ids") ? [searchParams.get("categoria_ids")] : []
  );

  // Variables para los modals (Extraidos de HOME PUBLICO)
  const [vIsModal, setVIsModal] = useState(false);
  const [vIsLogin, setVIsLogin] = useState(false);
  const [vIsEnviarCorreo, setEnviarCorreo] = useState(false);
  const [vIsCambioContraseñaTemporal, setCambioContraseñaTemporal] =
    useState(false);
  const [vIsRecetContraseña, setRecetContraseña] = useState(false);
  const [vIsContactanos, setVIsContactanos] = useState(false);

  const { width, height } = useContext(WindowSizeContext); // Se usa para calcular el tamaño de los MODALS
  const [vWidth, setVWidth] = useState(width - 20);

  const navigate = useNavigate();
  const irACursos = () => {
    navigate("/cursos");
  };
  //_________________________________________________________________________________//

  // UseEffect de los modals (Extraidos de HOME PUBLICO)
  useEffect(() => {
    if (searchParams.get("_tk")) {
      //localStorage.clear()
      localStorage.setItem("token", searchParams.get("_tk"));
      if (searchParams.get("_m") && searchParams.get("_m") == "reset") {
        mActivar_DesactivarModal("recetContraseña", true);
      } else {
        mActivar_DesactivarModal("cambiarContraseñaTemporal", true);
      }
    } else {
      mActivar_DesactivarModal();
    }
  }, [searchParams]);

  const mActivar_DesactivarModal = (vModalActivar, vIsActivo) => {
    const mResetearModals = () => {
      setEnviarCorreo(false);
      setCambioContraseñaTemporal(false);
      setRecetContraseña(false);
      setVIsLogin(false);
      setVIsContactanos(false);
    };
    setVIsModal(vIsActivo);
    if (!vIsActivo) {
      mResetearModals();
    } else {
      switch (vModalActivar) {
        case "enviarCorreo":
          mResetearModals();
          setEnviarCorreo(true);
          break;
        case "cambiarContraseñaTemporal":
          mResetearModals();
          setCambioContraseñaTemporal(true);
          break;
        case "recetContraseña":
          mResetearModals();
          setRecetContraseña(true);
          break;
        case "contactanos":
          mResetearModals();
          setVIsContactanos(true);

          break;
        case "login":
          mResetearModals();
          setVIsLogin(true);
          break;
        case "login":
          mResetearModals();
          setVIsLogin(true);
          break;

        default:
          mResetearModals();
          break;
      }
    }
  };
  //_____________________________________________________//

  const pageSize = 1;
  // En caso de que se reciba una categoría, la agregamos a un array, sino enviamos un array vacío.

  const mGetCategoriasFetch = () => {
    getCategoriaData()
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        // Manejo de diferentes tipos de errores basados en el código de estado
        switch (response.status) {
          case 400:
            console.log("Datos inválidos");
            throw new Error("ERR_VALIDATION");

          case 401:
            console.log("Acceso denegado");
            throw new Error("ERR_UNAUTHORIZED");

          case 500:
            console.log("Error al obtener categorias");
            throw new Error("ERR_SERVER");

          default:
            console.log("Error inesperado");
            throw new Error("ERR_UNKNOWN");
        }
      })
      .then((result) => {
        if (result !== undefined) {
          switch (result["detail"]["acción"]) {
            case "CATEGORIAS_OBTENIDAS":
              setVCategorias(result["detail"]["datos"]);
              break;

            default:
              break;
          }
        }
      })
      .catch((error) => {
        // Separar las propiedades del error
        const { message } = error;
        if (message !== "ERR_ME") {
          console.log("Error de red");
        }
      });
  };

  const mGetCursosEmpaginadosFetch = () => {
    getCursosEmpaginados(page, pageSize, vCategoriesSelected)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        // Manejo de errores según el status de la respuesta
        switch (response.status) {
          case 400:
            console.log("Datos inválidos");
            throw new Error("ERR_VALIDATION");
          case 401:
            console.log("Acceso denegado");
            throw new Error("ERR_UNAUTHORIZED");
          case 500:
            console.log("Error al obtener cursos");
            throw new Error("ERR_SERVER");
          default:
            console.log("Error inesperado");
            throw new Error("ERR_UNKNOWN");
        }
      })
      .then((result) => {
        if (result !== undefined && result.detail) {
          // Se espera que el endpoint devuelva "accion": "MOSTRAR_CURSOS"
          if (result.detail["acción"] === "MOSTRAR_CURSOS") {
            const datos = result.detail.datos;
            setVCursosPopulares(datos.cursos);
            setTotalPages(datos.paginas_totales);
            setTotalResultados(datos.total_resultados);
          }
        }
      })
      .catch((error) => {
        console.log("Error de red", error);
      });
  };

  // Se vuelve a llamar al endpoint cada vez que cambia el estado "page"
  useEffect(() => {
    mGetCursosEmpaginadosFetch();
  }, [page, vCategoriesSelected]);

  useEffect(() => {
    mGetCategoriasFetch();
  }, []);
  useEffect(() => {
    setPage(1); // Reinicia la paginación si cambian las categorías
  }, [vCategoriesSelected]);

  return (
    <div data-figma-id="238:10261" className="cursos-desktop">
      <div
        data-figma-id="238:9857"
        className="cursos-header"
        style={!vIsModal ? { width: vWidth } : { height: height }}
      >
        <UniversalMenuHeader
          mActivar_DesactivarModal={mActivar_DesactivarModal}
          nombrePaginaSeleccionada="Cursos"
        />
        {/* Insercion de los modals */}

        <UModalLogin
          vIsLogin={vIsLogin}
          mActivar_DesactivarModal={mActivar_DesactivarModal}
        />
        <UModalEnviarCorreo
          vIsEnviarCorreo={vIsEnviarCorreo}
          mActivar_DesactivarModal={mActivar_DesactivarModal}
        />
        <UModalContactanos
          vIsContactanos={vIsContactanos}
          mActivar_DesactivarModal={mActivar_DesactivarModal}
        />
        {vIsCambioContraseñaTemporal && (
          <UModalCambiarContraseñaTemporal
            vIsCambioContraseñaTemporal={vIsCambioContraseñaTemporal}
            mActivar_DesactivarModal={mActivar_DesactivarModal}
          />
        )}
        {vIsRecetContraseña && (
          <UModalRecetContraseña
            vIsRecetContraseña={vIsRecetContraseña}
            mActivar_DesactivarModal={mActivar_DesactivarModal}
          />
        )}
        {(!vIsModal || (width > 1439 && vIsModal)) && (
          <div data-figma-id="113:8881" class="home-barra-busqueda">
            <UniversalBarraBusqueda vCategoriasObtenidas={vCategorias} />
          </div>
        )}

        {/* _______________________________ */}
      </div>
      {/* Aqui esto se oculta o no dependiendo del modal */}
      {(!vIsModal || (width > 1439 && vIsModal)) && (
        <div data-figma-id="238:9861" className="cursos-contenido-2">
          <div data-figma-id="238:9862" className="cursos-contenido-header">
            <div
              data-figma-id="238:9863"
              className="cursos-contenido-header-titulos-2"
            >
              <img
                src="images/book-alt-1.svg"
                data-figma-id="238:10251"
                className="img-30"
                alt="Ícono de curso"
              />
              <p
                data-figma-id="238:9865"
                className="cursos-contenido-header-titulo-1-2"
              >
                Todos los cursos
              </p>
              <p
                data-figma-id="238:9866"
                className="cursos-contenido-header-titulo-2-2"
              >
                {totalResultados} cursos
              </p>
            </div>
            <div className="div-block-7">
              <SubEmpaginador
                page={page}
                setPage={setPage}
                totalPages={totalPages}
              />
            </div>
            <div className="filtros-barra-busqueda">
              <SubFilter
                vCategoriesSelected={vCategoriesSelected}
                setVCategoriesSelected={setVCategoriesSelected}
              />
            </div>
          </div>

          <div data-figma-id="238:9874" className="cursos">
            {vCursosPopulares.map((vCurso) => (
              <UniversalTarjetaCurso
                key={vCurso.id}
                vIdCurso={vCurso.id}
                categorias={vCurso.categorias}
                nombreCurso={vCurso.nombre}
                numTotalLecciones={vCurso.total_lecciones}
                numTotalHoras={vCurso.duracion}
                precioCurso={vCurso.precio}
              />
            ))}
          </div>

          <div className="div-block-7-copy">
            <SubEmpaginador
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          </div>
        </div>
      )}
    </div>
  );
}
